const showDaysThreshold = 2;
const showDaysHoursThreshold = 24;

const floor = Math.floor;

function f(count: number, label: string) {
  if (count === 1)
    return `${count} ${label}`;
  return `${count} ${label}s`;
}

function pad(value: number) {
  return value.toString(10).padStart(2, '0');
}

export function periodFormat(durationSeconds: number): string {
  const totalSeconds = floor(durationSeconds);
  const seconds = totalSeconds % 60;

  const totalMinutes = floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;

  const totalHours = floor(totalMinutes / 60);
  const hours = totalHours % 24;

  const days = floor(totalHours / 24);

  if (days >= showDaysThreshold)
    return f(days, 'day');
  if (totalHours >= showDaysHoursThreshold)
    return f(days, 'day') + ' ' + f(hours, 'hour');

  return hours + ':' + pad(minutes) + ':' + pad(seconds);
}
